import styled from "styled-components"

const AdressItemTaxo = styled.button`
  border: 1px solid
    ${(props) =>
      props.parent === true
        ? props.theme.c_color_gradients.c_dark
        : props.theme.b_color_gradients.b_dark};
  background-color: ${(props) =>
    props.active === true ? props.theme.b_color_gradients.b_dark : "white"};
  color: ${(props) => (props.active === true ? "white" : "black")};
  &::after {
    ${(props) =>
      props.active === true
        ? `
    content: " \\00D7";
    margin-left: 5px;
    line-height: 1;
    `
        : props.parent === true
        ? `
    content: " \\203A";
    display: inline-block;
    margin-left: 10px;
    transform: rotate(90deg);
    line-height: 1;
    `
        : null};
  }
`

const AdressItemTaxoNotClickable = styled.button`
  border: 1px solid ${(props) => props.theme.c_color_gradients.c_dark};
  background-color: ${(props) =>
    props.active === true ? props.theme.c_color_gradients.c_dark : "white"};
  color: ${(props) =>
    props.active === true ? props.theme.a_color_gradients.a_dark : "black"};
  &::after {
    ${(props) =>
      props.active === true
        ? `
      content: " \\2039";
      display: inline-block;
      margin-left: 10px;
      transform: rotate(90deg);
      line-height: 1;
      `
        : null};
  }
`

export { AdressItemTaxo, AdressItemTaxoNotClickable }
